<section class="safetytrainingrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>On Site Training</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-8" data-aos="fade-right" data-aos-delay="300">

                <div class="row">
                    <div class="col-lg-12">
                        <h3 class="theme_color">
                            <strong>
                            Personalized classes based on your needs:</strong>
                        </h3>

                        <p class="theme_color fontSize">
                            Need safety training at the job? <strong><a href="/contact" class="theme_color"><u>Contact us</u></a></strong> now to
                            schedule a personalized training class based on your needs.
                            We offer a wide range of classes like forklift
                            re/certification, mobile elevated work platform
                            certification, fall protection awareness, rigger signal person
                            training, scaffold competent person and many more!
                        </p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12">
                        <h3 class="theme_color">
                            <strong>
                            Ongoing Safety Training During Safety Inspections</strong>
                        </h3>

                        <p class="theme_color fontSize">
                            Training is an ongoing process. During our safety
                            inspections, our safety consultants train employees, and
                            subcontractors to minimize repeat infractions.
                        </p>
                        <p class="theme_color fontSize">
                            We handle safety infractions in a positive manner, by
                            explaining why it’s a hazard or OSHA violation and teaching
                            the workers how to correct the problem. We also explain
                            and train the workers the reasoning behind the safety issue
                            in question.

                        </p>
                        <p class="theme_color fontSize">
                            We have many offerings to make sure your site gets the
                            proper safety training from online, on-site, personalized
                            classes based on needs, and training room rentals. Each
                            training comes with a personalized completion card for
                            attendees that is valid for 3 years.
                        </p>

                        <p class="theme_color fontSize" style="font-size: large;">
                            <a href="https://lp.constantcontactpages.com/su/NexQzy
                            A/newslettersignup" target="_blank">
                                Want to stay in the loop when new
                                classes become available? Sign up
                                for our newsletter here!</a>
                        </p>

                    </div>
                </div>

            </div>
            <div class="col-lg-4" data-aos="fade-left" data-aos-delay="300" style="background-color: #032d57;">
                <div style="margin:10%;" class="white_fonts">
                    <h3>
                        <strong>Online Training</strong>
                    </h3>
                    <p class="theme_color fontSize">
                        SFI Compliance, Inc. has partnered with Red Vector to provide online safety training. Red Vector
                        is an OSHA authorized online training provider. This partnership allows us to provide quality
                        online training for those who cannot make it to a live class.
                    </p>
                    <a class="btn" style="background-color: #962824;color: white;"
                        href="https://sficompliance.redvector.com/default.aspx" target="_blank">
                        Learn More
                    </a>
                </div>

            </div>

        </div>        
    </div>
</section>